import api from "./axios";

export async function subirTicket(file, idlista) {
    const formData = new FormData();
    formData.append("file", file);
    if (idlista) {
        formData.append("idlista", idlista);
    }
    const { data } = await api.post("/tickets/", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
}

export async function obtenerTickets() {
    const { data } = await api.get("/tickets/");
    return data;
}

export async function eliminarTicket(idticket) {
    const { data } = await api.delete(`/tickets/${idticket}`);
    return data;
}
